import React from 'react'
import { motion } from 'framer-motion'

const ComparisonTable = () => {
  const features = [
    {
      feature: 'Fatigue physique',
      manual: '❌',
      expensive: '✅',
      emdrFlow: '✅'
    },
    {
      feature: 'Stimulation multi-sensorielle',
      manual: '❌',
      expensive: '⚠️',
      emdrFlow: '✅'
    },
    {
      feature: 'Contrôle discret',
      manual: '❌',
      expensive: '⚠️',
      emdrFlow: '✅'
    },
    {
      feature: 'Coût accessible',
      manual: '✅',
      expensive: '❌',
      emdrFlow: '✅'
    },
    {
      feature: 'Installation simple',
      manual: '✅',
      expensive: '❌',
      emdrFlow: '✅'
    },
    {
      feature: 'Personnalisation complète',
      manual: '❌',
      expensive: '⚠️',
      emdrFlow: '✅'
    },
    {
      feature: 'Synchronisation parfaite',
      manual: '❌',
      expensive: '✅',
      emdrFlow: '✅'
    }
  ]

  return (
    <section className="section-padding bg-slate-50">
      <div className="container-max">
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Pourquoi choisir EMDR Plus ?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comparaison objective avec les autres solutions du marché
          </p>
        </motion.div>

        <motion.div 
          className="overflow-x-auto"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <table className="w-full bg-white rounded-xl shadow-lg overflow-hidden">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">
                  Caractéristique
                </th>
                <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
                  Méthode manuelle
                </th>
                <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
                  Systèmes dédiés coûteux
                </th>
                <th className="px-6 py-4 text-center text-sm font-semibold text-white bg-primary-600">
                  EMDR Plus
                </th>
              </tr>
            </thead>
            <tbody>
              {features.map((row, index) => (
                <motion.tr 
                  key={index}
                  className="border-t border-gray-200"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <td className="px-6 py-4 text-sm text-gray-900 font-medium">
                    {row.feature}
                  </td>
                  <td className="px-6 py-4 text-center text-lg">
                    {row.manual}
                  </td>
                  <td className="px-6 py-4 text-center text-lg">
                    {row.expensive}
                  </td>
                  <td className="px-6 py-4 text-center text-lg bg-primary-50">
                    {row.emdrFlow}
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </motion.div>

        <motion.div 
          className="mt-8 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="flex justify-center space-x-8 text-sm text-gray-500">
            <div className="flex items-center space-x-2">
              <span className="text-lg">✅</span>
              <span>Excellent</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-lg">⚠️</span>
              <span>Partiel</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-lg">❌</span>
              <span>Insuffisant</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default ComparisonTable 